module.exports = __webpack_public_path__ + "static/media/1.cde2ef7d.jpg";